export const ACCESS_TOKEN = 'accessToken'
export const ID_TOKEN = 'idToken'
export const REFRESH_TOKEN = 'refreshToken'
export const API_CONFIG = 'apiConfig'
export const LOGIN_TYPE = 'loginType'
export const TIER_TYPE = 'tierType'
export const USER_PREFERENCE = 'userPreference'
